export default __webpack_public_path__ + "static/Montserrat-Light-b05de4483ff5a9843f9e7c7ca37f4bb0.woff2";